import React from 'react';

const TorExitNodeAdapterFieldSet = () => <fieldset />;

export default TorExitNodeAdapterFieldSet;
